module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp3_6005.a5d54982.png";